<template>
  <div class="page-wrapper">
    <div class="app-card-lg policy-card">
      <h1 class="policy-title">隐私政策</h1>
      <div class="policy-content">
        <p>更新时间：2026年4月10日</p>
        <p>生效时间：2026年4月10日</p>
        <p>
          本《隐私政策》适用于温岭 EATing 创意融合轻食提供的餐饮网站与微信小程序服务。
          温岭迅驰软件开发工作室作为技术支持方，为运营方提供系统开发、运维与技术保障，不参与餐饮运营及资金结算。
          我们重视并依法保护您的个人信息，请您在使用服务前仔细阅读本政策。
        </p>

        <h2>第一章 信息处理主体与角色说明</h2>
        <ul>
          <li>实际运营方（个人信息处理主要责任方）：温岭 EATing 创意融合轻食。</li>
          <li>技术支持方（受托技术处理）：温岭迅驰软件开发工作室，仅在运营方授权范围内提供技术服务。</li>
          <li>如涉及第三方支付、地图定位、消息通知等能力，由对应第三方依法处理其必要信息。</li>
        </ul>

        <h2>第二章 我们收集的信息类型与使用目的</h2>
        <h3>2.1 账号与身份信息</h3>
        <ul>
          <li>可能收集：微信标识（如 OpenID）、昵称、头像、手机号、登录凭证信息。</li>
          <li>使用目的：账号注册登录、身份识别、账号安全、客服沟通。</li>
        </ul>
        <h3>2.2 订餐、随心订与订单履约信息</h3>
        <ul>
          <li>可能收集：商品选择、餐次、订单金额、下单时间、订单状态、随心订周期、延期记录、兑换券使用记录。</li>
          <li>使用目的：生成订单、履约配送、售后处理、订单查询、对账审计与风控。</li>
        </ul>
        <h3>2.3 收货与配送信息</h3>
        <ul>
          <li>可能收集：收货人姓名、手机号、收货地址、配送备注、配送区域。</li>
          <li>使用目的：完成配送、联系收货人、处理异常订单。</li>
        </ul>
        <h3>2.4 支付与交易信息</h3>
        <ul>
          <li>可能收集：支付状态、支付流水标识、支付时间、退款状态。</li>
          <li>说明：银行卡号、支付密码等由持牌支付机构处理，我们不直接保存该等敏感支付凭据。</li>
        </ul>
        <h3>2.5 设备与日志信息</h3>
        <ul>
          <li>可能收集：设备型号、系统版本、操作日志、错误日志、访问时间、IP/网络环境等。</li>
          <li>使用目的：保障系统安全、排查故障、优化体验、满足审计合规要求。</li>
        </ul>

        <h2>第三章 信息处理的合法性基础与最小必要原则</h2>
        <ul>
          <li>我们依据法律法规、履行合同所必需、履行法定义务、保障交易安全等合法基础处理信息。</li>
          <li>我们遵循最小必要原则，仅收集实现业务功能所必需的信息。</li>
          <li>对于需要授权的能力（如地址、联系方式等），您可自主选择是否授权；拒绝授权可能影响对应功能使用。</li>
        </ul>

        <h2>第四章 信息共享、转让与公开披露</h2>
        <ul>
          <li>我们不会出售您的个人信息。</li>
          <li>仅在实现支付、配送、消息通知、客服处理等必要目的时，在最小必要范围内共享信息。</li>
          <li>如发生合并、分立、资产转让等情形导致信息转移，我们将依法告知并要求接收方继续受本政策约束。</li>
          <li>除法律法规另有规定或取得您的单独同意外，我们不会公开披露您的个人信息。</li>
        </ul>

        <h2>第五章 信息存储、安全与保留期限</h2>
        <ul>
          <li>信息原则上存储于中国境内。</li>
          <li>我们采取访问控制、权限隔离、加密传输、备份与审计等措施保护信息安全。</li>
          <li>我们仅在实现目的所需最短期限内保存个人信息，超期后将依法删除或匿名化处理。</li>
        </ul>

        <h2>第六章 您的权利</h2>
        <ul>
          <li>您有权查询、复制、更正、补充您的个人信息。</li>
          <li>在符合法律规定条件下，您有权请求删除个人信息、撤回授权、注销账号。</li>
          <li>如您认为信息处理行为侵害您的合法权益，可通过客服渠道投诉、举报或主张权利。</li>
        </ul>

        <h2>第七章 未成年人信息保护</h2>
        <ul>
          <li>本服务主要面向成年人。</li>
          <li>未成年人应在监护人同意和指导下使用服务；如发现未经监护人同意收集未成年人信息，我们将依法处置。</li>
        </ul>

        <h2>第八章 政策更新</h2>
        <ul>
          <li>我们可能根据法律法规及业务变化更新本政策。</li>
          <li>重大变更将通过弹窗、公告或页面提示方式告知；变更生效后继续使用服务视为您同意更新内容。</li>
        </ul>

        <h2>第九章 联系我们</h2>
        <ul>
          <li>运营方（实际经营）：温岭 EATing 创意融合轻食</li>
          <li>运营方联系方式：13958677072</li>
          <li>技术支持方：温岭迅驰软件开发工作室</li>
          <li>技术支持方联系方式：wenlingxunchi@163.com</li>
        </ul>
      </div>
      <div class="policy-footer">
        <el-button class="btn-primary" @click="$router.push('/login')">返回登录页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  min-height: 100vh;
  background: var(--page-bg);
  display: flex;
  justify-content: center;
}

.policy-card {
  max-width: 960px;
}

.policy-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-title);
  text-align: center;
  margin-bottom: 16px;
}

.policy-content {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-body);
}

.policy-content h2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
  margin-top: 16px;
  margin-bottom: 8px;
}

.policy-content h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-subtitle);
  margin-top: 12px;
  margin-bottom: 4px;
}

.policy-footer {
  margin-top: 24px;
  text-align: center;
}
</style>

